import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlSerializer, createUrlTreeFromSnapshot } from '@angular/router';
import { LoginService } from './login.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const loginService = inject(LoginService);
    if(!loginService.isloggedIn){
        const urlSerializer: UrlSerializer = inject(UrlSerializer);
        const redirectTo = urlSerializer.serialize(createUrlTreeFromSnapshot(route, ['.']));
        const router = inject(Router);
        router.navigate(['/account/login'], {queryParams: {redirectTo}})
    }
    return true;
}